// Countries data for the dropdown component
// This file centralizes all country information for better maintainability

export const countries = [
  { code: "UK", name: "Great Britain", flag: "🇬🇧" },
  { code: "DE", name: "Germany", flag: "🇩🇪" },
  { code: "FR", name: "France", flag: "🇫🇷" },
  { code: "ES", name: "Spain", flag: "🇪🇸" },
  { code: "IT", name: "Italy", flag: "🇮🇹" },
  { code: "CY", name: "Cyprus", flag: "🇨🇾" },
  { code: "AE", name: "Dubai", flag: "🇦🇪" },
  { code: "US", name: "USA", flag: "🇺🇸" },
  { code: "IL", name: "Israel", flag: "🇮🇱" },
  { code: "CH", name: "Switzerland", flag: "🇨🇭" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱" },
  { code: "LV", name: "Latvia", flag: "🇱🇻" },
  { code: "LT", name: "Lithuania", flag: "🇱🇹" },
  { code: "AT", name: "Austria", flag: "🇦🇹" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "TR", name: "Turkey", flag: "🇹🇷" },
  { code: "EE", name: "Estonia", flag: "🇪🇪" },
  { code: "CZ", name: "Czech Republic", flag: "🇨🇿" },
  { code: "GE", name: "Georgia", flag: "🇬🇪" },
  { code: "KZ", name: "Kazakhstan", flag: "🇰🇿" },
];

// Helper function to get country by code
export const getCountryByCode = (code) => {
  return countries.find((country) => country.code === code.toUpperCase());
};

// Helper function to get country by name
export const getCountryByName = (name) => {
  return countries.find((country) => country.name === name);
};

// Helper function to search countries
export const searchCountries = (query) => {
  const searchTerm = query.toLowerCase();
  return countries.filter(
    (country) =>
      country.name.toLowerCase().includes(searchTerm) ||
      country.code.toLowerCase().includes(searchTerm)
  );
};
